// ----------------------------------------------------------------------------
// Component: Tab
// ----------------------------------------------------------------------------
//
// TAB component with desktop tab functionality.
//
// Requires the following structure:
// .js-tab__item
//     .js-tab__button
//     .js-tab__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/icon/icon';

// Styles
import './_tabs.scss';


// -------------------------------------
// Variables
// -------------------------------------

const TAB_MOBILE            = '.js-tab--mobile';
const TAB_BUTTON_MOBILE     = '.js-tab__button--mobile';
const TAB_ITEM_MOBILE       = '.js-tab__item--mobile';
const TAB_CONTENT_MOBILE    = '.js-tab__content--mobile';
const TAB_TITLE_MOBILE      = '.js-tab__title--mobile';
const TAB_BUTTON_DESKTOP    = '.js-tab__button--desktop';
const TAB_CONTENT_DESKTOP   = '.js-tab__content--desktop';
const TABS_CONTAINER        = '.js-tabs--desktop';

// Constant trigger classes
const OPEN_CLASS            = 'is-open';

// Button Group
const BUTTON_GROUP_MOBILE   = $(TAB_BUTTON_MOBILE);
const BUTTON_GROUP_DESKTOP  = $(TAB_BUTTON_DESKTOP);


// -------------------------------------
// Helper Functions
// -------------------------------------

function handleMobileTab(tab) {
    tab.$item.parent().find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);

    tab.$item.parent().find(TAB_CONTENT_MOBILE).css('overflow', 'hidden');

    tab.$item.parent().find(TAB_BUTTON_MOBILE).attr('aria-expanded', 'false');

    tab.$item.parent().find(TAB_CONTENT_MOBILE + " a").attr('tabindex', -1);

    if (tab.isOpening) {
        tab.$button
            .add(tab.$item)
            .add(tab.$content)
            .addClass(OPEN_CLASS);

        tab.$button.attr('aria-expanded', 'true');
        tab.$content.attr('hidden', false);
        tab.$content.find('a').attr('tabindex', null);

        // This allows select boxes to flow out after it's opened
        setTimeout(function() {
            tab.$content.css('overflow', 'visible');
        }, 200);
    }
}

function tabOpen(tab) {
    const tab_id = tab[0].id;
    const tab_data = tab_id.replace("--button", "");
    const tab_conent_id = tab_data + "--content";
    const tab_conent = $("#" + tab_conent_id);
    

    if (!tab.hasClass(OPEN_CLASS)) {
        // Close all other Panels
        tab.siblings().find(TAB_BUTTON_DESKTOP).attr("aria-selected", "false");
        tab.siblings().find(TAB_BUTTON_DESKTOP).attr("tabindex", "-1");
        tab.siblings().removeClass(OPEN_CLASS);
        tab_conent.siblings().removeClass(OPEN_CLASS);

        // Toggle new panel
        tab.addClass(OPEN_CLASS);
        tab.attr("aria-selected", "true");
        tab.attr("tabindex", null);
        tab_conent.addClass(OPEN_CLASS);
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    $(TAB_CONTENT_MOBILE + " a").attr('tabindex', -1);

    $(TAB_BUTTON_MOBILE).on('click keydown', function(e){
        /**
         * click: Check state of the tab item then pass on an action
         *
         * @param {Event} e
         * @return void
         */
        //e.preventDefault();

        // Store $this for reference
        var $this = $(e.target);

        // Store elements as an object
        var tab = {};

        tab.$button    = $this;
        tab.$item      = $this.parents(TAB_ITEM_MOBILE);
        tab.$title     = $this.parents(TAB_TITLE_MOBILE);
        tab.$content   = tab.$title.siblings(TAB_CONTENT_MOBILE);
        tab.isOpening  = !$this.hasClass(OPEN_CLASS);
        tab.$container = $this.closest(TAB_MOBILE);

        // Collapse any open sibling & children tabs if data attribute set to true
        if (e.type === 'click') {
            e.preventDefault();
            handleMobileTab(tab);
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|38|40/)) {
                e.preventDefault();
                let index = $.inArray(e.target, BUTTON_GROUP_MOBILE);
                let length = BUTTON_GROUP_MOBILE.length;
                let newIndex;
                switch(key) {
                    case '38': // Up
                        newIndex = (index + length + -1) % length;
                        BUTTON_GROUP_MOBILE[newIndex].focus();
                        break;
                    case '40': // Down
                        newIndex = (index + length + 1) % length;
                        BUTTON_GROUP_MOBILE[newIndex].focus();
                        break;
                    case '35': // End
                        BUTTON_GROUP_MOBILE[length - 1].focus();
                        break;
                    case '36': // Home
                        BUTTON_GROUP_MOBILE[0].focus();
                        break;
                }
            }
        }
    });


    // Open first tab on page load
    $(TABS_CONTAINER).each(function(index) {
        $(this).find(TAB_BUTTON_DESKTOP).attr("tabindex", "-1");
        $(this).find(TAB_BUTTON_DESKTOP).first().addClass(OPEN_CLASS);
        $(this).find(TAB_BUTTON_DESKTOP).first().attr("aria-selected", "true");
        $(this).find(TAB_BUTTON_DESKTOP).first().attr("tabindex", null);
        $(this).children(TAB_CONTENT_DESKTOP).first().addClass(OPEN_CLASS);
    });


    // Card opens Panel
    $(TAB_BUTTON_DESKTOP).on('click keydown', function(e) {
        if (e.type === 'click') {
            e.preventDefault();
            tabOpen($(this));
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|37|39/)) {
                e.preventDefault();
                let index = $.inArray(e.target, BUTTON_GROUP_DESKTOP);
                let length = BUTTON_GROUP_DESKTOP.length;
                let newIndex;
                switch(key) {
                    case '37': // Up
                        newIndex = (index + length + -1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '39': // Down
                        newIndex = (index + length + 1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '35': // End
                        BUTTON_GROUP_DESKTOP[length - 1].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[length - 1]));
                        break;
                    case '36': // Home
                        BUTTON_GROUP_DESKTOP[0].focus();
                        tabOpen($(BUTTON_GROUP_DESKTOP[0]));
                        break;
                }
            } else {
                return true;
            }
        }
    });
});
